<template>
  <v-container>
    <v-card class="px-2">
      <input
        id="user-id"
        type="hidden"
        v-model="menu.id"
      />
      <input
        id="menu-uuid"
        type="hidden"
        v-model="menu.uuid"
      />
      <input
        id="menu-usuario"
        type="hidden"
        v-model="menu.usuario"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            outlined
            dense
          >
            <v-btn
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="codigo"
        >
          <v-checkbox
            v-model="menu.inativar"
            label="Inativar menu ?"
            color="success"
            v-show="mode === 'save'"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          md="4"
          sm="6"
        >
          <v-text-field
            label="Grupo de páginas do menu:"
            v-model="menu.bloco"
            required
            dense
            outlined
          >
            <v-btn
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadDialogPaginas"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          md="4"
          sm="6"
        >
          <v-autocomplete
            v-model="menu.groupId"
            :items="grupo"
            outlined
            dense
            label="Grupo Pai:"
            @change="loadParent()"
            clearable
            clear-icon="mdi-close-circle"
          ></v-autocomplete>
        </v-col>
        <v-col
          md="4"
          sm="6"
        >
          <v-autocomplete
            v-model="menu.parentId"
            :items="parent"
            outlined
            dense
            label="Menu Pai:"
            clearable
            clear-icon="mdi-close-circle"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          md="2"
          sm="6"
        >
          <v-text-field
            label="Nome:"
            type="text"
            v-model="menu.name"
            outlined
            dense
            :readonly="mode === 'remove'"
          ></v-text-field>
        </v-col>
        <v-col
          md="4"
          sm="6"
        >
          <v-text-field
            label="Descrição:"
            type="text"
            v-model="menu.ds_menu"
            outlined
            dense
            :readonly="mode === 'remove'"
          ></v-text-field>
        </v-col>
        <v-col
          md="2"
          sm="6"
        >
          <v-text-field
            label="Caminho curto:"
            v-model="menu.modulo"
            required
            dense
            outlined
            hint="Exemplo: paginasite"
          ></v-text-field>
        </v-col>
        <v-col
          md="4"
          sm="6"
        >
          <v-text-field
            label="Caminho completo:"
            v-model="menu.menu"
            required
            dense
            outlined
            hint="Exemplo: /imprensa/pagina-do-site"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          md="3"
          sm="6"
        >
          <v-text-field
            label="Ícone:"
            type="text"
            v-model="menu.file"
            outlined
            dense
            hint="Exemplo: mdi-folder-open"
          ></v-text-field>
        </v-col>
        <v-col
          md="6"
          sm="6"
        >
          <v-text-field
            label="Url externa:"
            type="text"
            v-model="menu.url"
            outlined
            dense
            hint="Exemplo: http://www.meusite.com.br/noticias"
          ></v-text-field>
        </v-col>
        <v-col
          md="3"
          sm="6"
        >
          <v-checkbox
            v-model="menu.interna"
            label="Usar url externa ?"
            color="success"
            class="mt-3 mv-3"
            v-show="mode === 'save'"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          md="6"
          sm="12"
        >
          <v-text-field
            v-model="menu.icone_url_menu"
            label="Url de ícone png"
            dense
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col
          md="3"
          sm="6"
        >
          <v-text-field
            v-model="menu.cor_menu"
            label="Cor do menu"
            dense
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col
          md="3"
          sm="6"
        >
          <v-checkbox
            v-model="menu.icon_png"
            label="Usar ícone png ?"
            color="success"
            class="mt-3 mv-3"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-card class="mb-4">
        <v-tabs
          v-model="tabs"
          background-color="grey darken-2"
          height="45"
          slider-color="primary"
          slider-size="1"
          dark
        >
          <v-tab
            :disabled="!menu.id"
            class="px-2 ml-1 py-0 white--text"
            active-class="primary"
          >
            <v-icon class="mr-2">
              mdi-eye
            </v-icon>
            Configurações
          </v-tab>
          <v-tab
            @click="loadDocs"
            :disabled="!menu.id"
            class="px-2 ml-1 py-0 white--text"
            active-class="primary"
          >
            <v-icon class="mr-2">
              mdi-paperclip
            </v-icon>
            Ícones e imagens
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Ícones ou imagens
                    </v-card-title>
                    <v-data-table
                      :headers="headersFotos"
                      :items="fotos"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadUrl(item)"
                        >
                          mdi-upload-network
                        </v-icon>
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadDoc(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="error"
                          class="mr-2"
                          @click="loadDoc(item, 'remove')"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="menu.id"
                          @click="loadAddFoto"
                        >
                          <v-icon left>
                            mdi-view-list
                          </v-icon>
                          Add ícones ou imagens
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row class="mb-2">
        <v-col xs="12">
          <v-btn
            color="primary"
            v-if="mode === 'save'"
            @click="save"
          >Salvar</v-btn>
          <v-btn
            color="danger"
            v-if="mode === 'remove'"
            @click="remove"
          >Excluir</v-btn>
          <v-btn
            class="ml-2"
            @click="reset"
          >Cancelar</v-btn>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar menus
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="fields"
                  :items="menus"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadMenu(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadMenu(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
    <v-container>
      <v-dialog
        v-model="vincFoto"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Vincular url à notícia
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="url.png_icon"
                        clearable
                        label="Url da imagem"
                        outlined
                        required
                        dense
                        v-if="mode === 'save'"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="menu.id"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="menu.id"
                    >
                      <v-checkbox
                        v-model="url.icon_png"
                        label="Usar ícone png?"
                        color="success"
                        class="mt-3 mv-3"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="menu.id"
                  @click="addImagemCapa()"
                >
                  <v-icon left>
                    mdi-autorenew
                  </v-icon>
                  Sinconizar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- Dialog de filtro de notícias -->
    <v-container>
      <v-dialog
        v-model="dialogPaginas"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialogPaginas">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar páginas
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >

              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="paginas"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadSelPaginas(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadSelPaginas(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialogPaginas.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container>
      <v-dialog
        v-model="addFoto"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar mídia
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="foto.usuario"
                  />
                  <input
                    id="foto-id"
                    type="hidden"
                    v-model="foto.id"
                  />
                  <input
                    id="uid_boletim"
                    type="hidden"
                    v-model="foto.uid_menu"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="foto.nome"
                        label="Nome do ícone"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="foto.inativar"
                        label="Inativar icone?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-mask="dtpub"
                            v-model="data_publicacao"
                            label="Data de publicação.:"
                            dense
                            outlined
                            @blur="mudaDataMidia"
                          >
                            <v-icon
                              slot="append"
                              color="success"
                              large
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="pt-br"
                          v-model="date1"
                          @input="dateF"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <input
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="ìcone do botão"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click.prevent="fileUpload()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="clearUpload"
                >
                  Remover
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import { uuid } from 'vue-uuid'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'MenuCategorys',
  computed: mapState(['user']),
  data: () => ({
    mode: 'save',
    codigo: '',
    search: '',
    dtpub: '##/##/####',
    tabs: null,
    vincFoto: false,
    uploadReady: true,
    date1: new Date().toISOString().substr(0, 10),
    dialogPaginas: false,
    dialog: false,
    addFoto: false,
    menu1: false,
    tabela: 'menuanexo',
    menu: {},
    icone: {},
    foto: {},
    url: {},
    fotos: [],
    grupo: [],
    parent: [],
    menus: [],
    pagina: {},
    paginas: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Módulo', value: 'modulo' },
      { text: 'Nome do módulo', value: 'nome_modulo' },
      {
        text: 'Breadcrumb',
        value: 'breadcrumbs',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    fields: [
      {
        text: 'Cod',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'name', sortable: true },
      { text: 'Bloco', value: 'bloco', sortable: true },
      { text: 'Caminho', value: 'path' },
      { text: 'Ativo', value: 'active' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFotos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url' },
      { text: 'Tam Arq.', value: 'size' },
      { text: 'Data', value: 'publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    dateF () {
      this.data_publicacao = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    loadMenus () {
      const url = `${baseApiUrl}/menu-categorias`
      axios.get(url).then(res => {
        this.menus = res.data.map(item => {
          return {
            ...item,
            active: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/upload-arquivos-diversos`
      formData.append('uid_menu', this.foto.uid_menu)
      formData.append('data_publicacao', this.date1)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.menu.id)
      formData.append('nome', this.foto.nome)
      formData.append('usuario', this.foto.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadDocs()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.foto.usuario = this.user.id
      this.foto.uid_menu = this.menu.id
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    reset () {
      this.mode = 'save'
      this.menu = {}
      this.icone = {}
      this.foto = {}
      this.url = {}
      this.codigo = ''
    },
    loadDialog () {
      this.dialog = true
      this.loadMenus()
    },
    save () {
      const method = this.menu.id ? 'put' : 'post'
      const id = this.menu.id ? `/${this.menu.id}` : ''
      axios[method](`${baseApiUrl}/menu-categorias${id}`, this.menu)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    addImagemCapa () {
      const id = this.menu.id
      axios.put(`${baseApiUrl}/add-icone-ao-menu/${id}`, this.url)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
        })
        .catch(showError)
    },
    remove () {
      const id = this.menu.id
      axios.delete(`${baseApiUrl}/menus/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    loadGrupo () {
      const url = `${baseApiUrl}/menu-categorias-gp`
      axios.get(url).then(res => {
        this.grupo = res.data.map(grupo => {
          return {
            value: grupo.id,
            text: grupo.name
          }
        })
      })
    },
    loadParent (gp) {
      const id = gp || this.menu.groupId
      const url = `${baseApiUrl}/menu-categorias-por-grupo/${id}`
      axios.get(url).then(res => {
        this.parent = res.data.map(parent => {
          return {
            value: parent.id,
            text: parent.path
          }
        })
      })
    },
    loadSelPaginas (item) {
      const id = this.codPagina ? this.codPagina : item.id
      const url = `${baseApiUrl}/paginas-param/${id}`
      axios.get(url).then(res => {
        this.pagina = res.data
        this.menu = {
          bloco: this.pagina.nome_modulo,
          name: this.pagina.titulo,
          ds_menu: this.pagina.subtitulo,
          modulo: this.pagina.modulo
        }
      })
      this.dialogPaginas = false
    },
    loadPaginas () {
      const url = `${baseApiUrl}/paginas-param`
      axios.get(url).then(res => {
        this.paginas = res.data
      })
    },
    loadDialogPaginas () {
      this.dialogPaginas = true
      this.codPagina = ''
      this.loadPaginas()
    },
    loadAddFoto () {
      this.foto.usuario = this.user.id
      this.foto.uid_menu = this.menu.id
      this.dateF()
      this.addFoto = true
    },
    loadMenu (item, mode = 'save') {
      const id = item.id
      const gp = item.groupId
      const url = `${baseApiUrl}/menu-categorias/${id}`
      axios.get(url).then(res => {
        this.menu = res.data
        this.codigo = this.menu.id
      })
      this.loadParent(gp)
      this.mode = mode
      this.dialog = false
    },
    loadUrl (icone, mode = 'save') {
      this.mode = mode
      this.icone = { ...icone }
      this.url.png_icon = this.icone.url
      this.url.icon_png = true
      this.vincFoto = true
    },
    loadDocs () {
      const idCd = this.menu.id
      const url = `${baseApiUrl}/arquivos-do-menu/${idCd}`
      axios.get(url).then(res => {
        this.fotos = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadDoc (doc, mode = 'save') {
      this.mode = mode
      const idDc = doc.id
      const url = `${baseApiUrl}/doc-param/${idDc}`
      axios.get(url).then(res => {
        this.doc = res.data
      })
      this.editDoc = true
    },
    loadUser () {
      this.menu.uuid = uuid.v1()
      this.menu.usuario = this.user.id
    }
  },
  mounted () {
    this.loadUser()
    this.loadGrupo()
  }
}
</script>

<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -13px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-size--default {
  height: 39px !important;
  min-width: 38px !important;
}
</style>
